const actionlocation = 'merchandising-module';

export const mlpModuleClick = theme => ({
  name: 'generic.event',
  data: {
    actionlocation,
    eventaction: 'merchandising-tile-click',
    eventcategory: 'module-click',
    eventrefinements: theme
  }
});

export const MLPMODULE_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const MLPMODULE_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
